import Breadcrumb from "@/components/BreadCrumb";
import Layout from "@/components/layout";
import webengage from "@/webengage";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";

const sectionPoints = [
  {
    name: "Commitment to Confidentiality",
    content:
      "Tradewise is dedicated to upholding the confidentiality of all data and information within its possession and is fully committed to safeguarding the privacy and security of user data. Tradewise is a web-based platform utilized by educators, trainers, coaches, and others to establish an online presence, cultivate a personal brand, launch cohort-based courses, and create a community of learners.",
  },
  {
    name: "User Consent and Acknowledgment",
    content:
      "All users of Tradewise acknowledge and consent to their use of the web platform via computers or smartphones. The users of services provided by educators, trainers, coaches, etc., on the web encompass students, learners, professionals, and others. Given the diverse user base of Tradewise, we are conscientious of the data we collect, utilize, process, store, share, and disclose.",
  },
  {
    name: "Integration with Terms and Conditions",
    content:
      "This policy should always be read and interpreted in conjunction with the website's terms and conditions",
  },
  {
    name: "Commitment to Confidentiality",
    content:
      "Tradewise is dedicated to upholding the confidentiality of all data and information within its possession and is fully committed to safeguarding the privacy and security of user data. Tradewise is a web-based platform utilized by educators, trainers, coaches, and others to establish an online presence, cultivate a personal brand, launch cohort-based courses, and create a community of learners.",
  },
  {
    name: "User Authentication",
    content:
      "The Company does not distinguish between individuals accessing the website from a device, as long as the login/access credentials match. To optimize website usage and ensure accurate information capture, it is imperative to log in using one's own credentials.",
  },
  {
    name: "Terminology",
    content: `In this policy, the pronouns "We," "Us," and "Our" collectively refer to the Company, and the pronouns "You," "Your," and "Yourself" are synonymous with "user". Terms not explicitly defined here shall carry the meanings attributed to them in the Terms of Use.`,
  },
  {
    name: "Privacy Policy Scope",
    content: `This privacy policy, along with any referenced documents, outlines Tradewise's stance and practices regarding the collection, processing, utilization, disclosure, storage, and transfer of Your information (the "Privacy Policy"). By engaging with Our web platform, including accessing it, using the services, and clicking the "I accept" button provided on the web, You express acceptance of Our information practices and this Privacy Policy. If the information provider, including personal information, is based in India, this Privacy Policy is considered an electronic record under Indian data privacy laws, and it does not necessitate a physical, electronic, or digital signature from Tradewise.`,
  },
  {
    name: "Information Collection",
  },
  {
    name: "Information We May Collect from You",
    content:
      "We collect and store information, including personal details, about You and Your interactions with Our web platform and services. This information is gathered through various means, as detailed below. Throughout this Privacy Policy, personal information refers to data capable of identifying a natural person directly or indirectly. Any other information (non-personal information) is data that does not lead to direct identification. Non-personal information may be collected, processed, used, disclosed, stored, and transferred for any purpose. While You have the option to withhold personal information, many such details are necessary to access Our web and services, and failure to provide them may restrict Your access.",
    bullets: [
      "Information provided on or through Our web or services, such as during registration, payment, or content posting.",
      "Details of Your web usage, including traffic and location data, weblogs, and communication patterns.",
      "Information related to Your activities and interactions on the web, including correspondence, internet protocol addresses, device and software data, and records of communication with Us.",
      "Data from surveys that You may choose to complete voluntarily.",
      "Content uploaded by You or other registered users in relation to You.",
    ],
    ps: "We also gather impersonal information necessary to provide and optimize Our services and Your interactions.",
  },
  {
    name: "User Representations and Warranties",
    content: "Users warrant and represent to the Company that:",
    bullets: [
      "All information provided is accurate, up-to-date, and correct.",
      "The provision of information does not breach any third-party agreements, laws, decrees, orders, or judgments.",
      "If information belongs to a third party, the user is authorized by the third party to use, access, and distribute it.",
      "The Company's officers, directors, contractors, or agents are not accountable for the authenticity or truthfulness of user-provided information.",
      "Users will indemnify and hold harmless the Company, its officers, directors, contractors, agents, and third parties relying on user-provided information in case of a breach of this Privacy Policy.",
    ],
  },
  {
    name: "Internet Protocol Addresses",
    content:
      "We may collect device information, including internet protocol addresses, operating systems, and browser types for system management and to provide aggregate data to advertisers and service providers. This information is statistical and does not identify individuals.",
  },
  {
    name: "Cookies",
    content:
      "We and Our service providers employ cookies and similar technologies (like web beacons) for various purposes. These technologies make it easier to access Our web and services, remember user preferences, improve user experiences, and analyze data. Cookies are small data files stored on devices during web usage. They help recognize repeat visits, store settings, and enhance web efficiency. Cookies do not identify individuals personally and do not enable identification on third-party websites.",
  },
  {
    name: "Disclaimer",
    content:
      "Some web features may be affected if cookies are disabled. Links on the web may lead to third-party sites with different privacy policies. Users access these links at their discretion, and the Company is not liable for third-party privacy breaches or objectionable content.",
  },
  {
    name: "Data Storage",
  },
  {
    name: "Where Your Personal Information Is Stored",
    content:
      "Data collected from You may be processed, stored, and maintained in systems located in India. If You are outside India and provide information, it may be transferred and processed in India. Additionally, Your information may be handled by staff outside India working for Us or service providers. By submitting information, You consent to transfer, storage, and processing as described.",
  },
  {
    name: "Security Measures",
    content:
      "We implement reasonable administrative, technical, physical, and managerial measures to protect personal information from unauthorized access. Industry-standard encryption protocols secure personal data transmitted to Us during registration and sign-up. While We prioritize data security, we cannot guarantee absolute security. Usage and transmission of data are at Your risk. Users must ensure appropriate safeguards to maintain data integrity.",
  },
  {
    name: "User Access and Rights",
  },
  {
    name: "User Rights",
    content:
      "Users can request not to process personal information for marketing. You can decline this processing during information collection or via email communication. Withdrawal of consent will affect access to Our web and services. In such cases, Your information may be deleted or de-identified.",
  },
  {
    name: "Intellectual Property and Changes",
  },
  {
    name: "Intellectual Property",
    content:
      "Tradewise is the Company's intellectual property. Materials on the website are protected by copyright, trademark, and intellectual property laws. Unauthorized use may breach these laws.",
  },
  {
    name: "Changes to Our Privacy Policy",
    content:
      "We may update this Privacy Policy periodically. Amendments will be effective upon posting. While We may notify users of changes, it's Your responsibility to stay informed. Continued use implies acceptance of changes.",
  },
  {
    name: "Confidentiality and Liability",
  },
  {
    name: "Confidentiality",
    content:
      "Users commit to treating accessed data with utmost confidentiality and not disclosing, sharing, manipulating, selling, or using data in violation of this Privacy Policy. Users will use information for Tradewise's benefit within business needs. Breach of confidentiality is subject to legal remedies.",
  },
  {
    name: "Limitation of Liability",
    content:
      "The Company is not liable for third-party actions or their breaches. Users indemnify the Company and its officers in case of a breach. Information transmitted may have errors or unauthorized access. The Company is not liable for third-party breaches or content. Users confirm accurate data submission and are liable for damages from false data. The Company implements reasonable security but is not liable for unauthorized disclosures by third parties.",
  },
  {
    name: "Severability and Google API Services",
  },
  {
    name: "Severability",
    content:
      "Provisions in this Privacy Policy are enforceable individually. Unenforceable clauses won't affect others.",
  },
  {
    bullets: [
      "Human access to user data is restricted unless explicit user consent has been secured for viewing specific messages, files, or other data.",
      "The data is not utilized or shared for ad-serving purposes, encompassing retargeting, personalized, or interest-based advertising.",
      "Data usage is confined to enhancing or providing user-facing features that prominently appear within the requesting application's user interface. All other uses of the data are prohibited.",
      "Data is only transferred to other entities when essential for enhancing or providing user-facing features prominently displayed within the requesting application's user interface.",
    ],
  },
];

const PrivacyPolicy = () => {
  return (
    <>
      <Head>
        <title>Privacy Policy | Tradewise</title>
        <meta
          name="description"
          content="Review Tradewise's Privacy Policy to understand how we protect your data. Learn about our data usage, security measures, and your privacy rights with us."
        />
      </Head>

      <Layout>
        <Breadcrumb />
        <div className="max-w-[700px] mx-auto">
          <Image
            src="/privacy-policy-hero.svg"
            width={234}
            height={213}
            alt="decorative image"
            className="mx-auto"
          />
          <h1 className="text-3xl font-bold leading-[22px] tracking-[0.25px] my-6">
            Privacy Policy
          </h1>
          <p>
            ESH Value Technologies Private Limited (referred to as "the Company"
            or "Tradewise") values the privacy of users who access the website{" "}
            <Link
              href="https://tradewiseapp.com/"
              className="underline text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://tradewiseapp.com/
            </Link>{" "}
            or engage with the Company through the web.
          </p>

          {sectionPoints.map((point, index) => (
            <div key={index}>
              <h2 className="text-2xl my-6">{point.name}</h2>
              {point.content && <p>{point.content}</p>}
              {point.bullets && (
                <ul>
                  {point.bullets.map((bullet, index) => (
                    <li key={index} className="flex gap-2 my-[10px]">
                      <Image
                        src="/checkbox.svg"
                        width={18}
                        height={18}
                        alt="bullet icon"
                        className="min-w-[22px] h-fit mt-1"
                      />
                      {bullet}
                    </li>
                  ))}
                </ul>
              )}
              {point.ps && <p>{point.ps}</p>}
            </div>
          ))}

          <h2 className="text-2xl my-6">Disclosure for Google API Services</h2>
          <p>
            Tradewise's utilization of information obtained through Google APIs
            is aligned with{" "}
            <Link
              href="https://developers.google.com/terms/api-services-user-data-policy"
              className="underline text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google API Services User Data Policy
            </Link>
            , which includes adherence to the{" "}
            <Link
              href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
              className="underline text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              Limited Use requirements
            </Link>
            .
          </p>
          <ul>
            {sectionPoints[sectionPoints.length - 1]?.bullets?.map(
              (bullet, index) => (
                <li key={index} className="flex gap-2 my-[10px]">
                  <Image
                    src="/checkbox.svg"
                    width={18}
                    height={18}
                    alt="bullet icon"
                    className="min-w-[22px] h-fit mt-1"
                  />
                  {bullet}
                </li>
              )
            )}
          </ul>

          <h2 className="text-2xl my-6">Contact Us</h2>
          <p>
            For inquiries, you can write an email to{" "}
            <Link
              href="mailto:ceo@thefuture.university"
              className="underline text-black"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                const _webengage = webengage();
                if (_webengage) {
                  _webengage.track("Contact Us", {
                    source: "Tradewise",
                    type: "Email",
                  });
                }
              }}
            >
              ceo@thefuture.university
            </Link>
            .
          </p>
        </div>
      </Layout>
    </>
  );
};

export default PrivacyPolicy;
